import TournamentList from '@pages/gamers/tournaments/tournaments';
export default TournamentList;
